export { default } from './AutoTaggingContainer'
